



































import { Component, Vue } from "vue-property-decorator";
import headerTitle from "@/components/headerTitle.vue";
import FilterBar from "./components/FilterBar.vue";
import { getLogList } from "@/req/account";
import { columnsList } from "./config";

@Component({
  components: {
    headerTitle,
    FilterBar,
  },
})
export default class Home extends Vue {
  public loading = false;
  public baseList = {
    type: "",
    username: "",
    begin_time: "",
    end_time: "",
  };
  public columns = columnsList;
  public data: any = [];
  public page = 1;
  public size = 10;
  public returnCurrent(currentPage) {
    if (typeof currentPage === "string") {
      return Number(currentPage);
    }
    return currentPage;
  }
  public mounted() {
    this.getList();
  }
  public change(index) {
    this.page = index;
    this.getList();
  }
  public sizeChange(size) {
    this.size = size;
    if (this.page == 1) {
      this.getList();
    }
  }
  public returnList(data) {
    this.baseList = data;
    this.page = 1;
    this.getList();
  }
  public async getList() {
    this.loading = true;
    const res = await getLogList({
      ...this.baseList,
      token: this.$fn.cookies.getToken("token"),
      page: this.page,
      size: this.size,
    });
    if (res.code == 0) {
      this.data = res.data;
      this.loading = false;
    }
  }
}
